import { render, staticRenderFns } from "./SimpleCarousel.vue?vue&type=template&id=680a0aea"
import script from "./SimpleCarousel.vue?vue&type=script&lang=js"
export * from "./SimpleCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports